import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { Card, CardBody, Table } from "reactstrap"
import { useDispatch } from "react-redux"

import Paginations from "components/Common/Pagination"
import { deleteCatering } from "store/actions/trialPeriodAction"
import { showAlert } from "store/reducers/alertReducer"
import DeleteModal from "components/Common/DeleteModal"
import NoDataAvailable from "components/Shared/NoDataAvailable"

const headers = [
  "S. No.",
  "Name",
  "Phone Number",
  "National ID",
  "Job Title",
  "Trial Operation",
  // "Action",
]

const EnrolledTable = ({
  onPageChange,
  data,
  currentPage,
  perPage,
  totalPages,
  totalCount,
  trigger,
  loading,
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [itemIdToDelete, setItemIdToDelete] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const handleDelete = () => {
    dispatch(deleteCatering(itemIdToDelete))
      .then(action => {
        const { statusCode, success, message } = action?.payload
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          trigger()
          setShowDeleteModal(false)
          setItemIdToDelete(null)
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(error => {})
  }

  return (
    <>
      <Card className="overflow-x-auto">
        <CardBody>
          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light full_th">
                <tr>
                  {headers.map((header, index) => (
                    <th key={index}>{t(header)}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={item.id}>
                    <th scope="row">
                      {(currentPage - 1) * perPage + index + 1}
                    </th>
                    <td>
                      <p>{item.user.name}</p>
                    </td>
                    <td>{item.user.phone}</td>
                    <td>{item.user.national_id}</td>
                    <td>{item.assign_job_title}</td>
                    <td>{item.trialRunSchedule.title}</td>
                    {/* <td>
                      <div className="d-flex gap-2 action_buttons">
                        <Button
                          color="danger"
                          onClick={() => {
                            setItemIdToDelete(item.uuid)
                            setShowDeleteModal(true)
                          }}
                          //   disabled={
                          //     isLoading && item?.uuid === itemIdToDelete
                          //   }
                          title={t("Delete")}
                        >
                          <Trash />
                        </Button>
                      </div>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {!loading && data.length === 0 && <NoDataAvailable />}
        </CardBody>
      </Card>
      {data.length !== 0 && (
        <Paginations
          currentPage={currentPage}
          totalPages={totalPages}
          totalCount={totalCount}
          onPageChange={onPageChange}
        />
      )}
      {showDeleteModal && itemIdToDelete && (
        <DeleteModal
          show={showDeleteModal}
          onDeleteClick={handleDelete}
          onCloseClick={() => {
            setItemIdToDelete(null)
            setShowDeleteModal(false)
          }}
          // isLoading={isLoading}
          buttonText={t("Delete")}
          bodyTitle={t("Are you sure you want to delete this {{name}}?", {
            name: t("Trial Operation"),
          })}
        />
      )}
    </>
  )
}

export default EnrolledTable
